export enum ELEMENTOS_RED_DE_RIEGO {
  POZO = 'pozo',
  BALSA = 'balsa',
  CABEZAL = 'cabezal',
  HIDRANTE = 'hidrante',
  TOMA = 'toma',
  ESTACION = 'estacion',
}
